<template>
  <form-field
    :label="label"
    :validation-errors="validationErrors"
    :label-for="forId"
    :help-text="helpText"
  >
    <!-- https://buefy.org/documentation/taginput  -->
    <b-taginput
      v-bind="$attrs"
      :id="forId"
      :value="value"
      :icon="icon"
      :placeholder="placeholder"
      @input="handleInput"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
      :before-adding="beforeAdding"
      :allow-new="!disallowNew"
      :size="size"
      expanded
    ></b-taginput>
  </form-field>
</template>

<script>
import FormField from "./FormField";
import {FormFieldMixin} from "./FormField.mixin";

export default {
  name: "FormFieldTagInput",
  components: {FormField},
  mixins: [FormFieldMixin],
  props: {
    value: {},
    placeholder: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
    },
    validationErrors: {
      type: [String, Array, undefined],
    },
    helpText: {
      type: String,
    },
    size: {
      type: String,
      default: 'is-small'
    },
    disallowNew: {
      type: Boolean,
      default: false,
    },
    beforeAdding: {
      type: Function,
    }
  },
  data() {
    return {
      forId: this.$utils.generateClientId(),
    }
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val);
      this.$emit('change', val);
      this.$emit('selected', val);

      this.emitGlobalFieldChangeEvent();
    },
  }
}
</script>

<style lang="scss">
.taginput {
  width: 100%;

  &-container.is-focusable {
    padding-right: 1px !important;
  }
}
</style>
